import { Link, useRouterState } from "@tanstack/react-router";

import { useAuth } from "@/auth/AuthContext";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const LINKS: { to: string; label: string }[] = [
  { to: "/inserate", label: "Inserate" },
  { to: "/objekte", label: "Objekte" },
];

/** Top navigation shown on every authenticated page. */
export function AppNav() {
  const { state, logout } = useAuth();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  if (state.status !== "authenticated") return null;

  return (
    <header className="sticky top-0 z-10 border-b bg-background/95 backdrop-blur">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <div className="flex items-center gap-6">
          <Link to="/inserate" className="text-base font-semibold">
            44er-immo
          </Link>
          <nav className="flex items-center gap-1">
            {LINKS.map((l) => {
              const active =
                pathname === l.to ||
                (l.to !== "/" && pathname.startsWith(l.to));
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className={cn(
                    "rounded-md px-3 py-1.5 text-sm transition-colors",
                    active
                      ? "bg-muted font-medium"
                      : "text-muted-foreground hover:bg-muted/50",
                  )}
                >
                  {l.label}
                </Link>
              );
            })}
          </nav>
        </div>

        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <span>
            <span className="font-medium text-foreground">
              {state.user.username}
            </span>
            {state.user.full_name ? ` (${state.user.full_name})` : null}
          </span>
          <Button variant="outline" size="sm" onClick={() => void logout()}>
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
}
